import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
interface LocationFormProps {
  onClose: () => void;
  location?: any; // Will be properly typed in next iteration
}
const LocationForm: React.FC<LocationFormProps> = ({
  onClose,
  location
}) => {
  const [formData, setFormData] = useState({
    name: location?.name || '',
    addressLine1: location?.addressLine1 || '',
    addressLine2: location?.addressLine2 || '',
    city: location?.city || '',
    state: location?.state || '',
    zip: location?.zip || '',
    country: location?.country || 'USA',
    contactName: location?.contactName || '',
    phone: location?.phone || '',
    email: location?.email || '',
    locationType: location?.locationType || 'Both',
    specialInstructions: location?.specialInstructions || '',
    directions: location?.directions || ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Validation and submission logic will be added in next iteration
    console.log('Form data:', formData);
    onClose();
  };
  return <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50" data-id="element-144">
      <div className="relative top-5 mx-auto p-5 border w-full max-w-2xl shadow-lg rounded-lg bg-white" data-id="element-145">
        <div className="flex justify-between items-center mb-4" data-id="element-146">
          <h2 className="text-xl font-semibold text-gray-800" data-id="element-147">
            {location ? 'Edit Location' : 'Add New Location'}
          </h2>
          <button onClick={onClose} className="p-1 rounded-full hover:bg-gray-100 transition-colors" data-id="element-148">
            <XIcon size={20} className="text-gray-500" data-id="element-149" />
          </button>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4" data-id="element-150">
          {/* Basic Information */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-151">
            <div data-id="element-152">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-153">
                Location Name*
              </label>
              <input type="text" required maxLength={30} value={formData.name} onChange={e => setFormData({
              ...formData,
              name: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-primary-500 focus:border-primary-500" data-id="element-154" />
            </div>
            <div data-id="element-155">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-156">
                Location Type*
              </label>
              <select required value={formData.locationType} onChange={e => setFormData({
              ...formData,
              locationType: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-primary-500 focus:border-primary-500" data-id="element-157">
                <option value="Pickup" data-id="element-158">Pickup Location</option>
                <option value="Delivery" data-id="element-159">Delivery Location</option>
                <option value="Both" data-id="element-160">Both</option>
              </select>
            </div>
          </div>
          {/* Address Fields */}
          <div className="space-y-4" data-id="element-161">
            <div data-id="element-162">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-163">
                Address Line 1*
              </label>
              <input type="text" required maxLength={30} value={formData.addressLine1} onChange={e => setFormData({
              ...formData,
              addressLine1: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-primary-500 focus:border-primary-500" data-id="element-164" />
            </div>
            <div data-id="element-165">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-166">
                Address Line 2
              </label>
              <input type="text" maxLength={30} value={formData.addressLine2} onChange={e => setFormData({
              ...formData,
              addressLine2: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-primary-500 focus:border-primary-500" data-id="element-167" />
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-168">
              <div className="col-span-2" data-id="element-169">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-170">
                  City*
                </label>
                <input type="text" required maxLength={19} value={formData.city} onChange={e => setFormData({
                ...formData,
                city: e.target.value
              })} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-primary-500 focus:border-primary-500" data-id="element-171" />
              </div>
              <div data-id="element-172">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-173">
                  State*
                </label>
                <input type="text" required maxLength={2} value={formData.state} onChange={e => setFormData({
                ...formData,
                state: e.target.value
              })} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-primary-500 focus:border-primary-500" data-id="element-174" />
              </div>
              <div data-id="element-175">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-176">
                  ZIP*
                </label>
                <input type="text" required maxLength={6} value={formData.zip} onChange={e => setFormData({
                ...formData,
                zip: e.target.value
              })} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-primary-500 focus:border-primary-500" data-id="element-177" />
              </div>
            </div>
          </div>
          {/* Contact Information */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-178">
            <div data-id="element-179">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-180">
                Contact Name
              </label>
              <input type="text" maxLength={20} value={formData.contactName} onChange={e => setFormData({
              ...formData,
              contactName: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-primary-500 focus:border-primary-500" data-id="element-181" />
            </div>
            <div data-id="element-182">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-183">
                Phone Number
              </label>
              <input type="tel" maxLength={20} value={formData.phone} onChange={e => setFormData({
              ...formData,
              phone: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-primary-500 focus:border-primary-500" data-id="element-184" />
            </div>
          </div>
          {/* Additional Information */}
          <div className="space-y-4" data-id="element-185">
            <div data-id="element-186">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-187">
                Special Instructions
              </label>
              <textarea rows={2} maxLength={70} value={formData.specialInstructions} onChange={e => setFormData({
              ...formData,
              specialInstructions: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-primary-500 focus:border-primary-500" data-id="element-188" />
            </div>
            <div data-id="element-189">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-190">
                Directions
              </label>
              <textarea rows={3} maxLength={500} value={formData.directions} onChange={e => setFormData({
              ...formData,
              directions: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-primary-500 focus:border-primary-500" data-id="element-191" />
            </div>
          </div>
          {/* Form Actions */}
          <div className="flex justify-end space-x-2 pt-4" data-id="element-192">
            <button type="button" onClick={onClose} className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500" data-id="element-193">
              Cancel
            </button>
            <button type="submit" className="px-4 py-2 border border-transparent rounded-md shadow-sm text-white bg-primary-700 hover:bg-primary-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500" data-id="element-194">
              {location ? 'Save Changes' : 'Add Location'}
            </button>
          </div>
        </form>
      </div>
    </div>;
};
export default LocationForm;